import { TrackingType } from '@app-types/tracking';

import { sendTracking } from '@helpers/tracking';

const baseTracking = {
    universe: 'Boutique_web',
    journey: 'ODR',
    eCommerceStep: 'Liste_produits',
};

function sendOdrTracking(tracking: TrackingType) {
    sendTracking(false, {
        ...baseTracking,
        ...tracking,
    });
}

export function sendOdrWallPageTracking() {
    sendOdrTracking({
        page: 'Mur_ODR',
        pageCategory: 'Liste_produits_ODR',
    });
}

export function sendOdrDateCalendarOpenTracking() {
    sendOdrTracking({
        page: 'Mur_ODR',
        action: 'Clic_affichage',
        category: 'Filtre_Date',
        name: 'Ouverture_plage_date',
    });
}

export function sendOdrDateSelectionTracking() {
    sendOdrTracking({
        page: 'Mur_ODR',
        action: 'Clic_selection',
        category: 'Filtre_Date',
        name: 'Selection_date',
    });
}

export function sendOdrSearchTracking() {
    sendOdrTracking({
        page: 'Mur_ODR',
        action: 'Clic_selection',
        category: 'Filtre_ZoneRecherche',
        name: 'Recherche',
    });
}

export function sendOdrDetailModalOpenTracking(odrTitle: string, availableCtas: string[]) {
    sendOdrTracking({
        page: 'Popin_details_ODR',
        variant: {
            propositions_envoi_demande: availableCtas,
        },
        variables: {
            detailODR: odrTitle,
        },
    });
}

export function sendOdrDownloadTracking() {
    sendOdrTracking({
        page: 'Popin_details_ODR',
        action: 'Clic_redirection',
        category: 'Mode_envoi_formulaire_ODR',
        name: 'Telecharger_le_coupon',
    });
}

export function sendOdrExternalLinkTracking() {
    sendOdrTracking({
        page: 'Popin_details_ODR',
        action: 'Clic_redirection',
        category: 'Mode_envoi_formulaire_ODR',
        name: 'Faire_la_demande_en_ligne',
    });
}
